import {
    GetFundingRequirementsCreditFacilityResponse,
    GetStateResponse
} from '@iwoca/lapi-client/edge';
import { mergeStates } from '../../../iwProvider/StoreHelper';
import {
    ADD_PHONE_NUMBER,
    CHANGE_PHONE_NUMBER,
    ONFIDO_VERIFICATION_DATA,
    ONFIDO_MAXIMUM_ATTEMPTS,
    PHONE_NUMBER_VALIDATION_ERROR,
    SEND_VERIFICATION_SMS_FAIL,
    SEND_VERIFICATION_SMS_PENDING,
    SEND_VERIFICATION_SMS_SUCCESS,
    TOGGLE_ADD_PHONE_NUMBER
} from './OnfidoVerificationModal.actions';
import {
    deserialiseOnfidoResponse,
    toggleAddPhoneNumber,
    updatePeopleState
} from './OnfidoVerificationModalHelper';
import { TDeserialisedPeople } from './OnfidoVerificationModal.types';

const initialState = {
    peopleToVerify: [],
    reachedMaxOnfidoAttempts: false
};

type TAction =
    | {
          type: typeof SEND_VERIFICATION_SMS_PENDING;
          personUID: string;
      }
    | {
          type: typeof SEND_VERIFICATION_SMS_FAIL;
          personUID: string;
      }
    | {
          type: typeof SEND_VERIFICATION_SMS_SUCCESS;
          personUID: string;
      }
    | {
          type: typeof PHONE_NUMBER_VALIDATION_ERROR;
          personUID: string;
      }
    | {
          type: typeof CHANGE_PHONE_NUMBER;
          personUID: string;
          phoneNumber: string;
      }
    | {
          type: typeof ADD_PHONE_NUMBER;
          personUID: string;
          phoneNumber: string;
      }
    | {
          type: typeof TOGGLE_ADD_PHONE_NUMBER;
          personUID: string;
      }
    | {
          type: typeof ONFIDO_VERIFICATION_DATA;
          customer_state: GetStateResponse['data'];
          funding_requirement: GetFundingRequirementsCreditFacilityResponse['data'];
      }
    | {
          type: typeof ONFIDO_MAXIMUM_ATTEMPTS;
      };

type TOnfidoState = {
    peopleToVerify: TDeserialisedPeople;
    reachedMaxOnfidoAttempts: boolean;
    SMSPending?: boolean;
    status?:
        | 'Verified'
        | 'Verifying your check'
        | 'Something went wrong'
        | 'Not started yet'
        | 'Something went wrong';
};

// eslint-disable-next-line import/no-default-export
export default function (
    state: TOnfidoState = initialState,
    action: TAction
): TOnfidoState {
    switch (action.type) {
        case SEND_VERIFICATION_SMS_PENDING:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { SMSPending: true }
                )
            });
        case SEND_VERIFICATION_SMS_FAIL:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { SMSPending: false, status: 'SMS failed' }
                )
            });

        case SEND_VERIFICATION_SMS_SUCCESS:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { SMSPending: false, status: 'SMS sent' }
                )
            });
        case PHONE_NUMBER_VALIDATION_ERROR:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { error: true }
                )
            });
        case CHANGE_PHONE_NUMBER:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { newPhoneNumber: action.phoneNumber, error: false }
                )
            });
        case ADD_PHONE_NUMBER:
            return mergeStates(state, {
                peopleToVerify: updatePeopleState(
                    state.peopleToVerify,
                    action.personUID,
                    { addPhoneNumberPending: true }
                )
            });
        case TOGGLE_ADD_PHONE_NUMBER:
            return mergeStates(state, {
                peopleToVerify: toggleAddPhoneNumber(
                    state.peopleToVerify,
                    action.personUID
                )
            });
        case ONFIDO_VERIFICATION_DATA:
            return mergeStates(
                state,
                deserialiseOnfidoResponse(
                    action.customer_state,
                    action.funding_requirement
                )!
            );

        case ONFIDO_MAXIMUM_ATTEMPTS:
            return mergeStates(state, { reachedMaxOnfidoAttempts: true });
        default:
            return state;
    }
}
